import { ProgramAttachment } from '../../types';
import { DivButton } from '../../../commons/components/DivButton';
import { CloseIcon } from '../../../assets/icons';
import React from 'react';
import { ImgPreview } from './ImgPreview';
import { VideoPreview } from './VideoPreview';

export const MediaPreview = (props: {
  programId: string;
  attachment: ProgramAttachment;
  canDelete: boolean;
  onDeleteAttachment: (attachment: ProgramAttachment) => void;
}) => {
  const { programId, attachment, canDelete, onDeleteAttachment } = props;

  return (
    <div className="carousel__media-container">
      {attachment.name.toLowerCase().endsWith('.mov') ||
      attachment.name.toLowerCase().endsWith('.mp4') ? (
        <VideoPreview programId={programId} attachment={attachment} />
      ) : (
        <ImgPreview programId={programId} attachment={attachment} />
      )}
      {canDelete && (
        <div className="carousel__delete-button-wrapper">
          <DivButton
            icon={<CloseIcon />}
            onClick={(e) => {
              onDeleteAttachment(attachment);
              e.stopPropagation();
              e.preventDefault();
            }}
            className="carousel__delete-button"
          />
        </div>
      )}
    </div>
  );
};
